import Mixin from "../mixin.js";
import moment from 'moment';
import Funnel from "../services/funnel-service.js";
import modal from "./modal.js";
import FormInputs from "../services/inputs-service.js";

const template = `
   <footer v-if="footer" :id="input.uid" role="contentinfo">
        <div class="grid">
            <component 
            :is="section.element" 
            v-for="(section,section_index) in input.footer_sections"  
            :id="'footer_section_'+section.element+'_'+section_index"
            v-bind="section.attr" 
            :key="'footer_section_'+section.element+'_'+section_index"
            v-if="fs.display(section)"
            >
                <component 
                v-for="(item,item_index) in section.children" 
                :is="item.element" 
                :key="'footer_'+item.element+'_'+item_index" 
                :id="'footer_'+item.element+'_'+item_index" 
                v-bind="item.attr"
                >
                    <div v-if="item.content" v-html="parseHtml(item.content)"></div>
                    <component 
                    v-if="item.element =='ul'" 
                    v-for="(list_item,list_item_index) in item.list_items" 
                    is="li" 
                    :key="'footer_list_item_'+list_item_index+'_li'" 
                    :id="'footer_list_item_'+list_item_index+'_li'"
                    >
                        <component 
                        :key="'footer_list_element_a_'+list_item_index+'_'+list_item.element" 
                        :id="'footer_list_element_a_'+list_item_index+'_'+list_item.element"
                        :is="list_item.element" 
                        v-bind="list_item.attr" 
                        @click="exec($event, list_item)"
                        v-html="parseHtml(list_item.content)"
                        />
                    </component>
                </component>
            </component>
        </div>

        <b-modal :iuid="modal" v-for="(modal, modal_index) in funnel.idsMap.modals" :key="modal.uid"/>
    </footer>
    `;
export default {
    name: 'b-progress',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components:{
        'b-modal': modal
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel'
        ]),
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        site_url: function(){
            return document.location.origin
        },
        year: function(){
            if ( this.$store.getters.funnel.elements[this.iuid] != undefined) {
                console.log("input: ",this.input);
                
            }
            return moment().format('YYYY')
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        footer: function () {
            return this.$store.getters.funnel.elements.footer;
        },
        baseLogoLink: function(){
            if(!this.browser_reload){
                if(this.template_set.includes("base")){ //AMS : We need to fild a way to differentiate partnered templates from normal templates- THIS IS NOT THE RIGHT WAY!! @Gabriel
                    return `static/images/template-set/${this.template_set}/${this.template_set}.svg`; //AMS : We need this in the DB- THIS IS NOT THE RIGHT WAY!! @Gabriel
                }
                return "";
            }
        },
        agent_phone: function() {
            if(Object.keys(this.funnel.elements).length > 0){
                return this.funnel.elements["sc_talk_it_out"]["phone"];
            }
        }
    },
    methods: {
        // John M: deprecated, see mixin.
        /* exec: function (e, input) {
            if (!input.fxn) {
                return
            }
            const fi = new FormInputs({ ctx: this.$store, router: this.$router });
            fi.eventHandler(e, input);
        }, */
    }
};